/**
 * @module app.bdc.reports.bdcNAPOldCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BDCNAPOldCtrl($scope, $window, $rootScope, pricesService, orderService, napService, offerService) {
        var self = {};
        self.orderForm = $rootScope.orderForm;
        self.user = $rootScope.user;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.order = $rootScope.order;
        pricesService.setOrderForm(self.orderForm);
        pricesService.setOrder(self.order);

        self.isRental = orderService.isRental(self.order.contract.contractType.code);
        self.contractMonths = orderService.getContractMonths(self.order);
        self.isOlderOffer = offerService.isOlderOffer(self.order);
        self.tills = [];
        self.isMixed = false;
        self.nbTills = orderService.getNbTills(self.order.tills);

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        /**
         * Get installation date if defined
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation() {
            return self.order.dateInstallation
                ? moment(self.order.dateInstallation, 'YYYY-MM-DD').format('MMMM YYYY')
                : null;
        };

        var _isAlreadyATill = false;

        /**
         * Get till pack description
         * @param {Object} order
         * @param {Boolean} isMixed
         * @param {Boolean} _isAlreadyATill
         * @return {String}
         */
        function _getDescription(isMixed, tillType) {
            return napService.getTillPackDescription(self.order, isMixed, _isAlreadyATill, tillType);
        }

        self.tillsConfig = self.order.tills.map(function(till) {
            return till.nbTills + ' ' + till.tillType.label + ' ' + till.label;
        });

        self.software = self.order.options.filter(function(option) {
            return option.optionType.code === 'LOGICIEL_CAISSE';
        });

        self.displayTotalPrice = function displayTotalPrice() {
            const promotionsTotalAmount = pricesService.calculatePromotionsTotalAmount(self.order.prices.promotions);
            return (
                (self.isRental ? self.order.prices.NAP.till.rental : self.order.prices.NAP.till.purchase) +
                self.order.prices.tillSoftware +
                self.order.prices.reintegration -
                promotionsTotalAmount
            );
        };

        /**
         * Init the tills list
         * If not mixed, a till = a line
         * If mixed, a line = a till familly
         */
        function _initTillsList() {
            var till = null;
            var nbTills = self.order.contract.scenarioType.code === 'EXTENSION' ? self.order.contract.nbTillsAdded : 1;
            var mixedTillTypes = orderService.areTillsMixed(self.order.tills);
            var mixedTills = {
                'BH+': [],
                BF: []
            };

            self.isMixed = mixedTillTypes.isMixed;

            for (var i = 0; i < self.order.tills.length; i++) {
                till = self.order.tills[i];
                for (var j = 0; j < self.order.tills[i].nbTills; j++) {
                    if (mixedTillTypes.isMixed && self.isOlderOffer) {
                        mixedTills[till.tillType].push(till.tillType.label + ' ' + till.label);
                    }
                    else {
                        self.tills[till.tillType.code] = {
                            reference: till.reference,
                            label: till.label,
                            description: _getDescription(false, till.tillType.code),
                            nbTills: 1,
                            pricePurchase:
                                pricesService.getSimpleTillPrice(till.tillType.code, nbTills, 'ACHAT') -
                                pricesService.getSimpleTillPrice(till.tillType, nbTills - 1, 'ACHAT'),
                            priceRental:
                                pricesService.getSimpleTillPrice(till.tillType.code, nbTills, 'LOC48') -
                                pricesService.getSimpleTillPrice(till.tillType, nbTills - 1, 'LOC48'),
                            tillType: till.tillType
                        };
                        nbTills++;
                    }
                }
            }

            if (mixedTillTypes.isMixed && self.isOlderOffer) {
                var nbTillsOrderModel = orderService.getNbTillsByTillType(self.order.tills);
                var pricesRental = pricesService.getMixedTillPrice(nbTillsOrderModel, 'LOC48');
                var pricesPurchase = pricesService.getMixedTillPrice(nbTillsOrderModel, 'ACHAT');

                self.tills.push({
                    reference: 'PACKNSBICBH',
                    label: mixedTills['BH+'].join(', '),
                    description: _getDescription(true),
                    nbTills: nbTillsOrderModel['BH+'],
                    pricePurchase: pricesPurchase['BH+'],
                    priceRental: pricesRental['BH+']
                });

                self.tills.push({
                    reference: 'PACKNSBICBH',
                    label: mixedTills['BF'].join(', '),
                    description: _getDescription(true),
                    nbTills: nbTillsOrderModel['BF'],
                    pricePurchase: pricesPurchase['BF'],
                    priceRental: pricesRental['BF']
                });
            }

            self.hasPromotion = function hasPromotion() {
                return self.order.promotions.length > 0;
            };
        }

        _initTillsList();

        return self;
    }

    BDCNAPOldCtrl.$inject = [
        '$scope',
        '$window',
        '$rootScope',
        'pricesService',
        'orderService',
        'napService',
        'offerService'
    ];

    angular.module('app.bdc.reports.bdcNAPOldCtrl', []).controller('BDCNAPOldCtrl', BDCNAPOldCtrl);
});
